//department service
import axios from 'axios'

export default {
    getDepartment(){
        return axios.get('/department')
            .then(response => {
                return response.data
            })
    },
    getDepartmentDataSource(params){
        return axios.get('/department/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getDepartmentbyID(id){
        return axios.get('/department/' + id)
            .then(response => {
                return response.data
            })
    },    
    getDepartmentDetails(id){
        return axios.get('/department/' + id + '/details')
            .then(response => {
                return response.data
            })
    }, 
    createDepartment(formdata){
        return axios.post('/department', formdata)
            .then(response => {
                return response.data
            })
    },
    updateDepartment(id,formdata){
        return axios.put('/department/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    destroyDepartment(id){
        return axios.delete('/department/' + id)
            .then(response => {
                return response.data
            })
    }, 
    assign_head_of_Department(id,formdata){
        return axios.put('/department/' + id + '/assign-as-hod', formdata)
            .then(response => {
                return response.data
            })
    },  
    remove_head_of_Department(id,formdata){
        return axios.put('/department/' + id + '/remove-hod', formdata)
            .then(response => {
                return response.data
            })
    },  
    assign_core_team_Department(id,formdata){
        return axios.put('/department/' + id + '/assign-as-core-team', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_core_team_Department(id,formdata){
        return axios.put('/department/' + id + '/remove-core-team', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_member_Department(id,formdata){
        return axios.put('/department/' + id + '/remove-member', formdata)
            .then(response => {
                return response.data
            })
    }, 
    getDepartmentDataSourceJoin(params){
        return axios.get('/department-app/join/datasource', {params})
            .then(response => {
                return response.data
            })
    },   
    deactivateJoin(id){
        return axios.put('/department-app/join/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateJoin(id){
        return axios.put('/department-app/join/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    updateBGImage(id,formData){
        return axios.post('/department/' + id + '/update_bgimage', formData)
            .then(response => {
                return response.data
            })
    },
    getDepartmentMessageDataSource(params){
        return axios.get('/department-message/datasource', {params})
            .then(response => {
                return response.data
            })
    },   
    createDepartmentMessage(formdata){
        return axios.post('/department-message/store', formdata)
            .then(response => {
                return response.data
            })
    },  
    updateDepartmentMessage(id,formdata){
        return axios.put('/department-message/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    destroyDepartmentMessage(id){
        return axios.delete('/department-message/' + id)
            .then(response => {
                return response.data
            })
    },
    getDepartmentMessagebyID(id){
        return axios.get('/department-message/' + id)
            .then(response => {
                return response.data
            })
    },   
}